import {
  UPDATE_TRANSLATION,
  SET_MODIFIED_TRANSLATIONS,
  ADD_FAQ_ROW
} from '../actionTypes'

export const updateTranslation = (lang, topic, key, value, path) => {
  return dispatch => {
    dispatch({
      type: UPDATE_TRANSLATION,
      lang,
      topic,
      key,
      value,
      path
    })
  }
}

export const setModifiedTranslations = translations => {
  return (dispatch, getState) => {
    dispatch({
      type: SET_MODIFIED_TRANSLATIONS,
      translations:
        translations || getState().i18n.translations
    })
  }
}

export const addFaqRow = () => ({
  type: ADD_FAQ_ROW
})
